// extracted by mini-css-extract-plugin
export default {"ldsRing":"Loading_ldsRing__kHW84"};